import { render, staticRenderFns } from "./AdaptationProduct.vue?vue&type=template&id=19e49c2c&scoped=true"
import script from "./AdaptationProduct.vue?vue&type=script&lang=js"
export * from "./AdaptationProduct.vue?vue&type=script&lang=js"
import style0 from "./AdaptationProduct.vue?vue&type=style&index=0&id=19e49c2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e49c2c",
  null
  
)

export default component.exports